import styled from 'styled-components'

export const Loading = styled.div`
  height: 50vh;
  width: 100%;
`
export const ExtraOptionsContainer = styled.div`
  &&&&& {
    opacity: 1;
    transition: height 1.3s;
    width: calc(100% - 34px);
    display: flex;
    padding: 24px;
    background-color: #f9f9fa;
    border-radius: 4px;
    border: 1px solid #e5eaeb;
    .field {
      margin-right: 16px;
    }
    .react-datetime-picker__button {
      display: flex;
      align-items: center;
    }
    div.field:last-child {
      margin-right: 0;
    }
  }
`
export const Container = styled.div`
  &&&& {
    transform-origin: top center;
    background-color: #fff;
    transition: height 300ms ease;
    i {
      cursor: pointer;
      top: -1px;
    }

    i.icon-calendar {
      cursor: pointer;
      top: -3px;
    }
    .field {
      margin: 0;
      label {
        margin-bottom: 0 !important;
      }
    }
  }
`
